import {Component, Input, OnInit} from '@angular/core';
import {Option} from '../../../back-office/Models/Option';

@Component({
  selector: 'app-child-item',
  templateUrl: './child-item.component.html',
  styleUrls: ['./child-item.component.scss']
})
export class ChildItemComponent implements OnInit {
  @Input() children: Option;
  constructor() { }

  ngOnInit() {
  }

}
